import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs/operators';
import { SspService } from 'src/app/services/ssp.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'upsc-guest-verification',
  templateUrl: './guest-verification.component.html',
  styleUrls: ['./guest-verification.component.scss']
})
export class GuestVerificationComponent implements OnInit {

  loading: boolean = false;
  systemError: boolean = false;
  isCanadaUser: boolean = false;

  constructor(
    private accountService: AccountService,
    private sspService: SspService,
    private userService: UserService,
    private auth: AuthService
  ) {
    this.isCanadaUser = this.userService.isCanadaUser()
  }

  ngOnInit(): void {
    this.loading = true;
    this.determineLoginState();
  }

  determineLoginState() {
    this.auth.idTokenClaims$.pipe(take(1)).subscribe(
      response => {
        if (!response) {
          this.loading = false;
          this.initiatePasswordlessAuth();
        } else {
          if (response.__raw && response.email) {
            if (response.sub.startsWith('auth0|')) {
              //User is logged in with a user's token. They should be logged out and redirected back here, session will recognize it is a valid guest URL but no token, so it will prompt for a new passwordless auth?
              this.auth.logout(
                { logoutParams: { 
                  returnTo: `${environment.baseUrl.web}guestVerify`
                } }
              );
              return;
            } else {
              this.setTokenAndGetPolicy(response.__raw, response.email);
            }
          } else {
            this.loading = false;
            this.systemError = true;
          }
        }
      }, error => {
        this.loading = false;
      }
    );
  }

  initiatePasswordlessAuth() {
    this.auth.loginWithRedirect({
      authorizationParams: {
        connection: 'email',
        // redirect_uri: 'http://localhost:4200/callback',
        redirect_uri: `${environment.baseUrl.web}callback`,
        'ext-connect': 'email' //additional param to indicate template to hide "sign up" and "login" text
      },
      appState: { target: '/guestVerify' }
    });
  }

  setTokenAndGetPolicy(id_token: string, email: string) {
    const partnerNameStr = sessionStorage.getItem('partnerName');
    let partnerName = partnerNameStr ? JSON.parse(partnerNameStr) : null;
    if (!partnerName) {
      this.loading = false;
      this.systemError = true;
      return;
    }
    let request = {
      id_token: id_token,
      workflow: partnerName
    }
    this.accountService.storePasswordlessToken(request).subscribe(
      response => {
        if (response && response?.responseMessage?.toLowerCase() != "success") {
          this.loading = false;
          this.systemError = true;
          return;
        }
        let request = {
          "partnerName": partnerName
        }
        this.sspService.getPartnerPolicy(request).subscribe(  //Retrieves Policy Number from Database
          response => {
            if (response && response.data.policyNumbers && response.data.policyNumbers.length > 0) {
              sessionStorage.setItem('policyNumber', response.data.policyNumbers[0]);
              sessionStorage.setItem('guestUserEmail', email);
              this.userService.loginForGuestUserNEW('/claims/new', false);
            } else {
              this.loading = false;
              this.systemError = true;
            }            
          }, error => {
            if (error && error?.status == 401) {
              //Most likely user has some session saved, but our database table no longer recognizes it for some reason, best would be to prompt user to enter verification code again
              this.initiatePasswordlessAuth();
            } else {
              //console.log("couldn't get partner policy, show an error");
              this.loading = false;
              this.systemError = true;
            }
          }
        );
      }, error => {
        //console.log("couldn't store token in database, show an error");
        this.loading = false;
        this.systemError = true;
      }
    );
  }
}
